export default __webpack_public_path__ + "static/media/130.c8620c5d.png";